import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [devUrl, setDevUrl] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      if (data.dev_reset_url) setDevUrl(data.dev_reset_url);
    } catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <form onSubmit={submit} className="w-full max-w-sm border border-border rounded-md bg-white p-8" data-testid="forgot-form">
        <h1 className="font-heading font-black text-2xl text-sapphire">Reset your password</h1>
        <p className="text-sm text-muted-foreground mt-1 mb-6">Enter your email and we'll send a reset link.</p>
        {sent ? (
          <div className="text-sm bg-emerald-50 border border-emerald-200 text-emerald-800 px-3 py-3 rounded flex gap-2" data-testid="forgot-sent">
            <MailCheck className="w-5 h-5 shrink-0" />
            <div>
              If an account exists for that email, a reset link has been sent. Check your inbox.
              {devUrl && <div className="mt-2 break-all"><a href={devUrl} className="text-ocean underline" data-testid="dev-reset-link">Open reset link (dev mode)</a></div>}
            </div>
          </div>
        ) : (
          <>
            {error && <div className="mb-4 text-sm bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded" data-testid="forgot-error">{error}</div>}
            <Label className="uppercase text-xs tracking-[0.2em] mb-1.5 block">Email</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" placeholder="you@example.com" />
            <Button type="submit" disabled={loading} className="w-full mt-6 bg-ocean hover:bg-ocean/90" data-testid="forgot-submit">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
            </Button>
          </>
        )}
        <p className="text-sm text-center mt-6 text-muted-foreground"><Link to="/login" className="text-ocean font-semibold" data-testid="back-to-login">Back to log in</Link></p>
      </form>
    </div>
  );
}
